import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-cfe1ca7c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "site-header__inner" }
const _hoisted_2 = {
  class: "site-header__brand",
  href: "/",
  "aria-label": "Startseite"
}
const _hoisted_3 = {
  class: "site-header__nav",
  "aria-label": "Hauptnavigation"
}
const _hoisted_4 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BrandLogo = _resolveComponent("BrandLogo")!

  return (_openBlock(), _createElementBlock("header", {
    class: _normalizeClass(["site-header", { 'site-header--vecura': _ctx.isVecura }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("a", _hoisted_2, [
        _createVNode(_component_BrandLogo, {
          variant: _ctx.isVecura ? 'vecura' : 'default'
        }, null, 8, ["variant"])
      ]),
      _createElementVNode("nav", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.navItems, (item) => {
          return (_openBlock(), _createElementBlock("a", {
            key: item.href,
            class: _normalizeClass([{
            'site-header__link--active': _ctx.isActive(item.href),
            'site-header__link--featured': item.featured,
          }, "site-header__link"]),
            href: item.href
          }, _toDisplayString(item.label), 11, _hoisted_4))
        }), 128))
      ])
    ])
  ], 2))
}